if (!window.RationalFuturismForm) {
    class RationalFuturismForm {
        constructor(formElement) {
            this.form = formElement || document.querySelector('form[action*="/cart/add"]');
            this.container = this.form ? (this.form.closest('.product') || this.form.closest('.shopify-section') || this.form) : document.body;

            if (!this.container) {
                console.error("❌ RF: Container not found!");
                return;
            }
            console.log("🚀 RF: Form Initializing...");

            this.config = window.rfConfig || {};
            // [FIX] Prefer rfConfig.mainVariants as it contains full option/availability data
            if (this.config.mainVariants) {
                this.productData = { variants: this.config.mainVariants, title: this.config.productTitle || "" };
            } else {
                this.productData = window.rfShopifyData || {};
            }
            this.formType = String(this.config.formType || 'unknown').trim();

            console.log("RF: Booting with Form Type:", this.formType);

            try {
                const fb = window.RF_FIREBASE;
                if (fb) {
                    this.storage = fb.storage;
                    console.log("🔥 RF: Firebase Initialized Successfully (via RF_FIREBASE)");
                } else {
                    console.warn("⏳ RF: RF_FIREBASE not yet available, will retry on upload");
                }
            } catch (err) {
                console.error("❌ RF: Firebase Initialization Failed", err);
                alert("システムエラー: ファイルアップロード機能が初期化できませんでした。");
            }

            this.uploadedFiles = [];
            this.currentBasePrice = 0;
            this.testPrintPrice = 0;

            // Dynamic Size List
            this.STANDARD_SIZES = STANDARD_SIZE_DICT; // [FIX] Bind global dict to instance for usage in helpers
            this.availableSizes = this.parseProductSizes();

            this.elements = {
                sizeSelect: this.container.querySelector('#rf-size-select'),
                sizeModeRadios: document.querySelectorAll('input[name="rf-size-mode"]'),
                standardContainer: this.container.querySelector('#rf-size-standard-container'),
                customContainer: this.container.querySelector('#rf-size-custom-container'),
                customShort: this.container.querySelector('#rf-size-short'),
                customLong: this.container.querySelector('#rf-size-long'),
                customDisplay: this.container.querySelector('#rf-custom-display'),
                priceDisplay: this.container.querySelector('#rf-price-display'),
                layoutSection: this.container.querySelector('#rf-section-layout'),
                layoutRadios: document.querySelectorAll('input[name="properties[印刷レイアウト]"]'),
                borderlessSection: this.container.querySelector('#rf-section-borderless'),
                dataSection: this.container.querySelector('#rf-section-data'),
                marginSection: this.container.querySelector('#rf-section-margin'),
                marginWidthInputs: this.container.querySelector('#rf-margin-width-inputs'),
                marginSizeInputs: this.container.querySelector('#rf-margin-size-inputs'),
                dropzone: this.container.querySelector('#rf-dropzone'),
                fileInput: this.container.querySelector('#rf-file-input'),
                fileList: this.container.querySelector('#rf-file-list'),
                uploadError: this.container.querySelector('#rf-upload-error'),
                hiddenFileNames: this.container.querySelector('#rf-file-names'),
                hiddenFileUrls: this.container.querySelector('#rf-file-urls'),
                totalAmountDisplay: this.container.querySelector('#rf-total-price') || this.container.querySelector('#rf-total-amount'),
                // Qty
                qtyMinus: this.container.querySelector('#rf-qty-minus'),
                qtyPlus: this.container.querySelector('#rf-qty-plus'),
                qtyInput: this.container.querySelector('#rf-qty-input'),
                // Test Print
                testPrintCheck: this.container.querySelector('#rf-check-test-print'),
                testPrintDetails: this.container.querySelector('#rf-test-print-details'),
                testPrintQtyInput: this.container.querySelector('#rf-tp-qty-input'),
                testPrintMinus: this.container.querySelector('#rf-tp-qty-minus'),
                testPrintPlus: this.container.querySelector('#rf-tp-qty-plus'),
                testPrintData: this.container.querySelector('#rf-test-print-data'),
                testPrintFilename: this.container.querySelector('#rf-tp-filename'),
                testPrintAddress: this.container.querySelector('#rf-tp-address')
            };

            // Test Print Logic Init
            if (this.elements.testPrintData) {
                this.testPrintPrice = parseInt(this.elements.testPrintData.dataset?.price) || 0;
                this.testPrintVariantId = this.elements.testPrintData.dataset?.variantId;
            } else {
                this.testPrintPrice = 0;
                this.testPrintVariantId = null;
            }

            // Track last checked layout for toggle/deselect behavior
            this.lastLayoutRadio = document.querySelector('input[name="properties[印刷レイアウト]"]:checked');

            this.initListeners();
            if (typeof this.setupVisibility === 'function') this.setupVisibility(); // [NEW] Initial visibility setup
            this.initHelperModal(); // [NEW] Layout Help Modal
            this.disableNumberScroll();



            // Init total
            this.updateTotalDisplay();

            // Init state check (for reload or default checks)
            this.checkInitialLayout();

            // Init Size Price from default selection (A5)
            if (this.elements.sizeSelect && this.elements.sizeSelect.value) {
                this.handleSizeSelectChange({ target: this.elements.sizeSelect });
            }
        }



        checkInitialLayout() {
            const checkedLayout = (this.container && typeof this.container.querySelector === 'function')
                ? this.container.querySelector('input[name="properties[印刷レイアウト]"]:checked')
                : null;
            if (checkedLayout) {
                this.handleLayoutChange({ target: checkedLayout });
            }
        }

        parseProductSizes() {
            const sizes = [];
            if (!this.productData.variants) return sizes;

            this.productData.variants.forEach(variant => {
                // [NEW] Skip sold out items
                if (!variant.available) return;

                const title = variant.title;
                let width = 0, height = 0;

                // 1. Try to find dimensions in title e.g. "200x200", "200×200"
                const dimMatch = title.match(/(\d+)\s*[x×]\s*(\d+)/);
                if (dimMatch) {
                    width = parseInt(dimMatch[1]);
                    height = parseInt(dimMatch[2]);
                } else {
                    // 2. Try Dictionary Lookup (e.g. "A4")
                    // Clean title: remove stuff in parens if needed, or exact match
                    // Strategy: Check if title *starts with* a known key
                    for (const [key, dims] of Object.entries(STANDARD_SIZE_DICT)) {
                        // Check exact match or "Key (" or "Key（" or "Key /" (Unified)
                        if (title === key || title.startsWith(key + '(') || title.startsWith(key + '（') || title.startsWith(key + ' /')) {
                            width = dims[0];
                            height = dims[1];
                            break;
                        }
                    }
                }

                if (width > 0 && height > 0) {
                    sizes.push({
                        name: title, // Use Variant Title as name
                        short: Math.min(width, height),
                        long: Math.max(width, height),
                        id: variant.id,
                        price: variant.price,
                        options: [variant.option1, variant.option2, variant.option3] // [NEW] Capture options
                    });
                }
            });

            // Sort sizes by Area (Small -> Large) for fitting logic
            sizes.sort((a, b) => (a.short * a.long) - (b.short * b.long));

            // [NEW] Trigger UI availability check immediately
            // (Wait for DOM to be ready implicitly or call it?)
            // Since we are in constructor and element exists, we can call it.
            setTimeout(() => this.updateAvailabilityUI(), 0);

            return sizes;
        }

        // [NEW] Update UI Availability based on Valid Variants
        updateAvailabilityUI() {
            // 1. Size Dropdown: Hide options that have NO available variants
            if (this.elements.sizeSelect) {
                const options = this.elements.sizeSelect.querySelectorAll('option');
                const variants = this.productData?.variants || [];

                // [FIX] If no variants or all unavailable, show all options (fallback)
                const hasAnyAvailable = variants.some(v => v.available);
                if (variants.length === 0 || !hasAnyAvailable) {
                    console.log("RF: updateAvailabilityUI - No available variants, showing all options.");
                    options.forEach(opt => {
                        if (opt.value === "") return;
                        opt.style.display = '';
                        opt.hidden = false;
                        opt.disabled = false;
                    });
                    return;
                }

                options.forEach(opt => {
                    if (opt.value === "") return; // Skip placeholder

                    // Check if there is AT LEAST ONE available variant with this Size (Option1)
                    const hasStock = variants.some(v =>
                        v.available && v.option1 === opt.value
                    );

                    if (!hasStock) {
                        // [MODIFIED] Hide instead of Disable
                        opt.style.display = 'none';
                        opt.hidden = true; // Support for some browsers
                        opt.disabled = true; // Fallback ensure unselectable
                    } else {
                        opt.style.display = '';
                        opt.hidden = false;
                        opt.disabled = false;
                        // Remove (売切れ) if it was added (cleanup from previous logic if persistent)
                        opt.textContent = opt.textContent.replace(' (売切れ)', '');
                    }
                });
            }
        }

        // [NEW] Update Available Colors for Selected Size
        updateAvailableColors(sizeValue) {
            if (!sizeValue) return;

            // [FIX] Skip color filtering for forms where color options are independent of size
            // wood_panel has 側面テープカラー which is the same for all sizes
            if (['wood_panel', 'book_matte'].includes(this.formType)) return;

            const isUnified = ['aluminum_unified', 'wood_unified'].includes(this.formType);

            // [FIX] For unified forms, use customOptions (from JSON) instead of productData.variants
            // Filter by product handle to avoid cross-product matching
            let sourceVariants;
            if (isUnified && this.customOptions && this.customOptions.length > 0) {
                const productHandle = this.formType === 'aluminum_unified' ? 'framing-p002' : 'framing-p001';
                sourceVariants = this.customOptions.filter(v => v.product_handle === productHandle);
            } else {
                sourceVariants = this.productData?.variants || [];
            }

            // Find all available variants for this size
            const validVariants = sourceVariants.filter(v => {
                const opt1 = v.options ? v.options[0] : v.option1;
                // For unified JSON, there's no 'available' property, assume all are available
                const isAvailable = v.available !== undefined ? v.available : true;
                return isAvailable && opt1 === sizeValue;
            });

            // Extract available Color values (Option 2 or Option 3)
            const availableColors = new Set(validVariants.map(v => {
                if (isUnified) {
                    return v.options ? v.options[2] : v.option3;
                } else {
                    let colorOpt = v.options ? v.options[1] : v.option2;
                    if (!colorOpt && v.options && v.options[2]) {
                        colorOpt = v.options[2];
                    } else if (!colorOpt && v.option3) {
                        colorOpt = v.option3;
                    }
                    return colorOpt;
                }
            }));

            console.log(`RF: updateAvailableColors - Size: ${sizeValue}, Available Colors:`, [...availableColors]);

            // Update Color Inputs
            const colorInputs = this.container.querySelectorAll('input[name="properties[フレームカラー]"], input[name="properties[側面カラー]"], input[name="properties[テープカラー]"], input[name="properties[側面テープカラー]"]');
            colorInputs.forEach(input => {
                const colorVal = input.value;
                const parent = input.closest('.rf-radio-card, label');

                if (availableColors.has(colorVal)) {
                    input.disabled = false;
                    if (parent) {
                        // [MODIFIED] Show
                        parent.style.display = '';
                        parent.classList.remove('rf-disabled');
                        parent.style.opacity = '1';
                        parent.style.pointerEvents = 'auto';
                    }
                } else {
                    input.disabled = true;
                    if (parent) {
                        // [MODIFIED] Hide
                        parent.style.display = 'none'; // Hide completely per request

                        // If this was checked, uncheck it
                        if (input.checked) {
                            input.checked = false;
                            parent.classList.remove('active');
                        }
                    }
                }
            });

            // [FIX] If no colors are shown, show the color section anyway with all colors
            if (availableColors.size === 0) {
                colorInputs.forEach(input => {
                    input.disabled = false;
                    const parent = input.closest('.rf-radio-card, label');
                    if (parent) {
                        parent.style.display = '';
                        parent.classList.remove('rf-disabled');
                        parent.style.opacity = '1';
                        parent.style.pointerEvents = 'auto';
                    }
                });
            }
        }

        initListeners() {
            // Layout Radios (Toggle/Deselect Logic)
            if (this.elements.layoutRadios) {
                this.elements.layoutRadios.forEach(radio => {
                    radio.addEventListener('click', (e) => {
                        if (this.lastLayoutRadio === radio) {
                            // Deselect if clicking already selected
                            radio.checked = false;
                            this.lastLayoutRadio = null;
                            this.handleLayoutChange({ target: radio });
                        } else {
                            this.lastLayoutRadio = radio;
                        }
                        this.updateTotalDisplay(); // Add this line
                        this.updateVisualState(); // Add this line
                    });
                });
            }

            // Size Mode Switcher
            if (this.elements.sizeModeRadios && typeof this.elements.sizeModeRadios.forEach === 'function') {
                this.elements.sizeModeRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => this.handleSizeModeChange(e));
                });
            }

            // --- Size Switcher True Toggle ---
            // Overrides native radio behavior to allow "flip on any click"
            const switcher = this.container.querySelector('.rf-size-switcher');
            if (switcher && typeof switcher.addEventListener === 'function') {
                switcher.addEventListener('click', (e) => {
                    // Prevent native label/radio default handling
                    e.preventDefault();

                    const standardRadio = this.container.querySelector('#rf-mode-standard');
                    const customRadio = this.container.querySelector('#rf-mode-custom');

                    // Toggle Logic
                    if (standardRadio.checked) {
                        customRadio.checked = true;
                        // Dispatch change manually since we prevented default
                        customRadio.dispatchEvent(new Event('change', { bubbles: true }));
                    } else {
                        standardRadio.checked = true;
                        standardRadio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            }

            // Size Select (Standard)
            if (this.elements.sizeSelect && typeof this.elements.sizeSelect.addEventListener === 'function') {
                this.elements.sizeSelect.addEventListener('change', (e) => this.handleSizeSelectChange(e));
            }

            // [FIX] Paper Type Select Logic (Explicit Binding)
            if (this.elements.paperSelect) {
                this.elements.paperSelect.addEventListener('change', (e) => {
                    this.handlePaperTypeChange(e);
                });
            }

            // Custom Size Input Updates
            [this.elements.customShort, this.elements.customLong].forEach(el => {
                if (el && typeof el.addEventListener === 'function') {
                    el.addEventListener('input', () => this.updateCustomCalculation());
                }
            });

            // Layout Radio Change (with Deselect Logic)
            if (this.elements.layoutRadios && typeof this.elements.layoutRadios.forEach === 'function') {
                this.elements.layoutRadios.forEach(radio => {
                    radio.addEventListener('click', (e) => {
                        if (radio.dataset.wasChecked === "true") {
                            radio.checked = false;
                            radio.dataset.wasChecked = "false";
                            this.handleLayoutChange({ target: radio });
                        } else {
                            this.elements.layoutRadios.forEach(r => { if (r.dataset) r.dataset.wasChecked = "false"; });
                            radio.dataset.wasChecked = "true";
                            this.handleLayoutChange({ target: radio });
                        }
                        this.updateTotalDisplay();
                        this.updateVisualState();
                    });
                });
            }

            // Margin Type Radio Change
            const marginRadios = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('input[name="properties[フチ処理]"]')
                : [];
            if (marginRadios && typeof marginRadios.forEach === 'function') {
                marginRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => {
                        this.handleMarginTypeChange(e);
                        this.updateTotalDisplay();
                        this.updateVisualState();
                    });
                    if (radio.checked) {
                        this.handleMarginTypeChange({ target: radio });
                    }
                });
            }

            // Test Print Listeners
            if (this.elements.testPrintCheck && typeof this.elements.testPrintCheck.addEventListener === 'function') {
                this.elements.testPrintCheck.addEventListener('change', (e) => {
                    this.handleSimpleToggle(e.target.checked, this.elements.testPrintDetails);
                    this.updateTotalDisplay();
                });
            }
            if (this.elements.testPrintMinus && typeof this.elements.testPrintMinus.addEventListener === 'function') {
                this.elements.testPrintMinus.addEventListener('click', (e) => { e.preventDefault(); this.updateTestPrintQty(-1); });
            }
            if (this.elements.testPrintPlus && typeof this.elements.testPrintPlus.addEventListener === 'function') {
                this.elements.testPrintPlus.addEventListener('click', (e) => { e.preventDefault(); this.updateTestPrintQty(1); });
            }
            if (this.elements.testPrintQtyInput && typeof this.elements.testPrintQtyInput.addEventListener === 'function') {
                this.elements.testPrintQtyInput.addEventListener('change', () => this.updateTestPrintQty(0));
            }

            // Quantity Logic
            if (this.elements.qtyMinus && typeof this.elements.qtyMinus.addEventListener === 'function') this.elements.qtyMinus.addEventListener('click', () => this.updateQuantity(-1));
            if (this.elements.qtyPlus && typeof this.elements.qtyPlus.addEventListener === 'function') this.elements.qtyPlus.addEventListener('click', () => this.updateQuantity(1));
            if (this.elements.qtyInput && typeof this.elements.qtyInput.addEventListener === 'function') this.elements.qtyInput.addEventListener('change', () => this.updateQuantity(0));

            // [Unified] Processing Type Change
            const procRadios = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('input[name="rf-processing-type"]')
                : [];
            if (procRadios && typeof procRadios.forEach === 'function') {
                procRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => {
                        console.log("RF: Processing Type Changed ->", e.target.value);
                        if (typeof this.setupVisibility === 'function') this.setupVisibility(); // Original line
                        if (typeof this.updateLayoutWarningVisibility === 'function') this.updateLayoutWarningVisibility(); // [NEW] Sync Layout Warning
                        if (typeof this.updateTotalDisplay === 'function') this.updateTotalDisplay();
                        if (typeof this.updateVisualState === 'function') this.updateVisualState();
                    });
                });
            }

            // Initial check for processing type related visibility and warnings
            if (typeof this.updateLayoutWarningVisibility === 'function') this.updateLayoutWarningVisibility(); // [NEW] Initial Sync

            // Focus Mode Interactions (Grouped) - PC Only (>=900px)
            const sections = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('.rf-section')
                : [];
            if (sections && typeof sections.forEach === 'function') {
                sections.forEach(section => {
                    if (!section || typeof section.addEventListener !== 'function') return;
                    section.addEventListener('mouseenter', () => {
                        // [MODIFIED] Only enable focus mode on Desktop
                        if (window.innerWidth < 900) return;

                        const currentGroup = section.dataset.focusGroup;
                        sections.forEach(s => {
                            if (!s || !s.dataset) return;
                            const targetGroup = s.dataset.focusGroup;
                            // If same section OR (both have groups AND groups match), don't dim.
                            const isRelated = (s === section) || (currentGroup && targetGroup && currentGroup === targetGroup);

                            if (!isRelated) s.classList.add('rf-dimmed');
                            else s.classList.remove('rf-dimmed');
                        });
                    });
                    section.addEventListener('mouseleave', () => {
                        // Always clear on leave, just in case
                        sections.forEach(s => { if (s && s.classList) s.classList.remove('rf-dimmed'); });
                    });
                });
            }

            // [NEW] Caption Panel Toggles
            const captionOptionCheck = this.container.querySelector('#rf-check-caption-option');
            const captionDetails = this.container.querySelector('#rf-caption-details');
            if (captionOptionCheck && captionDetails && typeof captionOptionCheck.addEventListener === 'function') {
                captionOptionCheck.addEventListener('change', (e) => {
                    this.handleSimpleToggle(e.target.checked, captionDetails);
                    // Also trigger validation or other updates if needed
                });
            }

            const captionTemplateSelect = this.container.querySelector('#rf-caption-template');
            const designInstructionGroup = this.container.querySelector('#rf-caption-design-instruction');
            if (captionTemplateSelect && designInstructionGroup && typeof captionTemplateSelect.addEventListener === 'function') {
                captionTemplateSelect.addEventListener('change', (e) => {
                    const isTypeA = e.target.value === 'Aタイプ';
                    this.toggleContent(designInstructionGroup, isTypeA);
                });
                // Initial check
                this.toggleContent(designInstructionGroup, captionTemplateSelect.value === 'Aタイプ');
            }

            // [NEW #P30328] レイアウト確認チェックボックスで納期テキスト動的変更
            const layoutConfirmChecks = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('input[name="properties[レイアウト確認]"]')
                : [];
            if (layoutConfirmChecks && typeof layoutConfirmChecks.forEach === 'function') {
                layoutConfirmChecks.forEach(check => {
                    if (check && typeof check.addEventListener === 'function') {
                        check.addEventListener('change', () => {
                            this.updateShippingPrefixText();
                        });
                    }
                });
            }
            // Initial check
            this.updateShippingPrefixText();


            // File Upload - ROBUST BINDING
            // [FIX] Use a flag to prevent double binding
            if (this._uploadListenersBound) {
                console.log("⏭️ RF: Upload listeners already bound, skipping.");
            } else {
                const dz = this.container.querySelector('#rf-dropzone');
                const inp = this.container.querySelector('#rf-file-input');

                if (dz && inp && typeof dz.cloneNode === 'function') {
                    console.log("✅ RF: File Upload Elements Found. Binding listeners now.");
                    this._uploadListenersBound = true;

                    // [FIX] Clone BOTH dropzone and file input to prevent duplicate listeners
                    const newDz = dz.cloneNode(true);
                    if (dz.parentNode) {
                        dz.parentNode.replaceChild(newDz, dz);
                    }
                    this.elements.dropzone = newDz;

                    // [FIX] Re-acquire the file input from the cloned dropzone
                    const newInp = newDz.querySelector('#rf-file-input') || this.container.querySelector('#rf-file-input');
                    this.elements.fileInput = newInp;

                    // Re-bind Click
                    this.elements.dropzone.addEventListener('click', (e) => {
                        if (e.target === newInp || e.target.closest('.rf-file-remove')) return;
                        console.log("🖱️ RF: Dropzone clicked. Triggering input click...");
                        newInp.click();
                    });

                    // CRITICAL FIX: Stop propagation from input to prevent infinite loop
                    newInp.addEventListener('click', (e) => e.stopPropagation());

                    // Re-bind Input Change
                    newInp.addEventListener('change', (e) => {
                        console.log("📂 RF: File input changed", e.target.files);
                        if (e.target.files && e.target.files.length > 0) {
                            this.handleFiles(e.target.files);
                        }
                    });

                    // Re-bind Drag Events
                    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
                        this.elements.dropzone.addEventListener(eventName, (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }, false);
                    });
                    ['dragenter', 'dragover'].forEach(eventName => {
                        this.elements.dropzone.addEventListener(eventName, () => this.elements.dropzone.classList.add('rf-dragover'), false);
                    });
                    ['dragleave', 'drop'].forEach(eventName => {
                        this.elements.dropzone.addEventListener(eventName, () => this.elements.dropzone.classList.remove('rf-dragover'), false);
                    });
                    this.elements.dropzone.addEventListener('drop', (e) => {
                        const dt = e.dataTransfer;
                        console.log("⬇️ RF: File Dropped", dt.files);
                        this.handleFiles(dt.files);
                    }, false);

                } else {
                    console.error("❌ RF: Critical Error - File Upload Elements MISSING", { dz, inp });
                }
            }

            // Add to Cart Button Logic (Deferred to ensure ID is injected)
            // Add to Cart Button Logic (Deferred to ensure ID is injected)
            // [FIX] Consolidate Listener Logic
            const initRobustCart = () => {
                // Wait slightly for liquid script to run
                setTimeout(() => {
                    const form = document.querySelector('form[action$="/cart/add"]');
                    // [FIX] Try Custom ID first, then fallback to Native Theme Button (name="add")
                    const addToCartBtn = this.container.querySelector('#rf-add-to-cart') || form?.querySelector('button[name="add"]');

                    if (addToCartBtn) {
                        console.log("✅ RF: Add to Cart Button Found. Binding listener.");
                        this.elements.addToCartBtn = addToCartBtn;

                        // Remove existing listeners (theme default) by cloning
                        const newBtn = addToCartBtn.cloneNode(true);
                        addToCartBtn.parentNode.replaceChild(newBtn, addToCartBtn);
                        this.elements.addToCartBtn = newBtn;

                        newBtn.addEventListener('click', (e) => {
                            console.log("🛒 RF: Cloned Button Clicked");
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            this.handleRobustSubmit(e);
                        });
                    } else {
                        console.warn("⚠️ RF: Add to Cart Button NOT found via ID #rf-add-to-cart or name='add'");
                    }

                    if (form) {
                        // [FIX] Block Implicit Form Submission (Enter key, etc)
                        form.addEventListener('submit', (e) => {
                            console.log("🛑 RF: Native Form Submit Blocked");
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }, { capture: true });
                    }

                }, 100);
            };

            if (document.readyState === 'loading') {
                if (typeof document.addEventListener === 'function') {
                    document.addEventListener('DOMContentLoaded', initRobustCart);
                }
            } else {
                initRobustCart();
            }

            // Tooltip
            if (typeof document.body.addEventListener === 'function') {
                document.body.addEventListener('mouseover', (e) => {
                    if (e.target && e.target.classList && e.target.classList.contains('rf-tooltip-trigger')) {
                        this.showTooltip(e.target);
                    }
                });
                document.body.addEventListener('mouseout', (e) => {
                    if (e.target && e.target.classList && e.target.classList.contains('rf-tooltip-trigger')) {
                        this.hideTooltip();
                    }
                });

                // Info Popover Logic (Delegated)
                document.body.addEventListener('click', (e) => {
                    // 1. Trigger Logic
                    const trigger = e.target && typeof e.target.closest === 'function' ? e.target.closest('.rf-info-trigger') : null;
                    if (trigger) {
                        // Desktop Check: Prevent JS click on PC (Hover only)
                        if (window.innerWidth > 768) return;
                        e.preventDefault();
                        e.stopPropagation();
                        console.log("ℹ️ RF: Info Trigger Clicked (Mobile)");

                        const popover = this.container.querySelector('#rf-info-modal-global');

                        if (popover) {
                            // Check visibility (flex or block just in case)
                            const isVisible = popover.style.display === 'flex' || popover.style.display === 'block';

                            if (!isVisible) {
                                // Fix: Set 'flex' immediately so centering works
                                popover.style.display = 'flex';
                                requestAnimationFrame(() => {
                                    popover.classList.add('rf-active');
                                });
                            } else {
                                // Instant Close (User Requested)
                                popover.classList.remove('rf-active');
                                popover.style.display = 'none';
                            }
                        }
                        return;
                    }

                    // 2. Close Button Logic
                    const closeBtn = e.target.closest('.rf-popover-close-btn');
                    if (closeBtn) {
                        e.preventDefault();
                        const popover = closeBtn.closest('.rf-info-popover');
                        if (popover) {
                            popover.classList.remove('rf-active');
                            popover.style.display = 'none';
                        }
                        return;
                    }

                    // 3. Backdrop Click Logic (Global Modal)
                    const globalModal = this.container.querySelector('#rf-info-modal-global');
                    // Check against flex as well
                    if (globalModal && (globalModal.style.display === 'block' || globalModal.style.display === 'flex')) {
                        // If click target IS the backdrop container (not child), close it
                        if (e.target === globalModal) {
                            e.preventDefault();
                            console.log("ℹ️ RF: Backdrop Clicked");
                            globalModal.classList.remove('rf-active');
                            globalModal.style.display = 'none';
                        }
                    }
                });

            }
        }

        initHelperModal() {
            const btn = this.container.querySelector('#rf-layout-help-btn');
            const modal = this.container.querySelector('#rf-layout-modal');
            if (btn && modal && typeof btn.addEventListener === 'function' && typeof modal.addEventListener === 'function') {
                // Open
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (modal.style) modal.style.display = 'flex';
                    // Small delay to allow display:flex to apply before opacity transition
                    requestAnimationFrame(() => {
                        if (modal.classList) modal.classList.add('rf-active');
                    });
                });

                // Close on Backdrop Click OR Close Button Click (Delegation)
                modal.addEventListener('click', (e) => {
                    // 1. Backdrop Click
                    if (e.target === modal) {
                        e.preventDefault();
                        modal.classList.remove('rf-active');
                        setTimeout(() => { modal.style.display = 'none'; }, 300);
                        return;
                    }

                    // 2. Close Button Click (Delegation)
                    const closeBtnIn = e.target.closest('#rf-layout-modal-close') || e.target.closest('.rf-modal-close');
                    if (closeBtnIn) {
                        e.preventDefault();
                        modal.classList.remove('rf-active');
                        setTimeout(() => { modal.style.display = 'none'; }, 300);
                    }
                });
            }
        }


        async handleRobustSubmit(e) {
            if (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
            console.log("RF: Submit Clicked");

            if (this.isSubmitting) {
                console.warn("RF: Skipped - Already submitting");
                return;
            }

            // 1. Validate Custom Form
            if (!this.validateForm()) {
                console.log("RF: Validation Failed");
                this.isSubmitting = false; // Reset lock if validation fails
                return false;
            }

            // [FIX #P30546] Block Submission if Uploads Pending
            const uploadingItems = this.elements.fileList.querySelectorAll('.rf-file-item:not(.rf-upload-complete):not(.rf-error)');
            if (uploadingItems.length > 0) {
                alert("ファイルのアップロード中です。完了するまでお待ちください。");
                this.isSubmitting = false;
                return false;
            }
            // Also check for errors?
            const errorItems = this.elements.fileList.querySelectorAll('.rf-file-item.rf-error');
            if (errorItems.length > 0) {
                alert("エラーが発生したファイルがあります。削除してから注文してください。");
                this.isSubmitting = false;
                return false;
            }

            // Ensure hidden inputs are up to date
            this.updateHiddenFilesInput();

            // [NEW] Validate File Quantities (Async)
            // We await the result because it might show a modal
            const qtyValid = await this.validateTotalQuantity(null, true);
            if (!qtyValid) {
                console.log("RF: Quantity Validation Failed/Cancelled");
                this.isSubmitting = false; // Reset lock
                return false;
            }

            this.isSubmitting = true;
            const btn = this.container.querySelector('.rf-btn-add-to-cart');
            if (btn) {
                btn.textContent = '処理中...';
                btn.disabled = true;
            }

            const form = this.container.closest('form');

            // 2. Prepare Payload (Manual Construction)
            setTimeout(() => {
                try {
                    const formData = new FormData(form);
                    const payload = {};
                    for (let [key, value] of formData.entries()) {
                        payload[key] = value;
                    }

                    let hiddenJSON = {};
                    try {
                        hiddenJSON = JSON.parse(payload['properties[_acpaHidden]']);
                    } catch (e) {
                        // console.log('RF: _acpaHidden parse failed', e);
                    }

                    // Create a clean form for submission
                    const cleanForm = document.createElement('form');
                    cleanForm.method = 'POST';
                    cleanForm.action = '/cart/add';
                    cleanForm.style.display = 'none';

                    const appendInput = (name, value) => {
                        const inp = document.createElement('input');
                        inp.type = 'hidden';
                        inp.name = name;
                        inp.value = value;
                        cleanForm.appendChild(inp);
                    };

                    // Copy Basic inputs (Quantity, Variant ID, etc.)
                    for (let [key, val] of formData.entries()) {
                        if (!key.startsWith('properties[')) {
                            appendInput(key, val);
                        }
                    }

                    // Prepare Properties
                    const propertiesToSend = {};
                    const acoCompatibility = { "_acoValidationDone": "true" };

                    // Process JSON to populate properties and compatibility map
                    // We trust the JSON structure from Aco but ensure our values are reflected
                    for (const key in hiddenJSON) {
                        const item = hiddenJSON[key];
                        if (item.label) {
                            let val = item.value;

                            // Handle array values safely
                            if (Array.isArray(item._value)) {
                                if (item._value.length === 0) {
                                    // Default fallback for empty specific fields
                                    if (item.label.includes('ファイル') || item.label.includes('入稿') || item.label.includes('レイアウト')) {
                                        val = "なし";
                                        item._value = ["なし"];
                                        item.value = "なし";
                                    } else {
                                        val = "";
                                    }
                                } else {
                                    val = item._value.join(',');
                                }
                            }

                            if (!val && (item.label.includes('ファイル') || item.label.includes('入稿'))) {
                                val = "なし";
                            }

                            if (val !== undefined && val !== null && val !== "") {
                                // CLEANUP: Prevent resurrection of legacy/duplicate keys
                                if (item.label === '入稿ファイル情報' || item.label === 'ファイルアップロード' || item.label === '入稿データURL') continue;

                                propertiesToSend[item.label] = val;
                                acoCompatibility[item.label] = val;
                            }
                        }
                    }

                    // Standardize Custom Field Values (Overwrite with actual selections)

                    // Layout Confirmation
                    const myConfirm = this.container.querySelector('input[name="properties[レイアウト確認]"]');
                    if (myConfirm) {
                        const confirmVal = myConfirm.checked ? '希望する' : '希望しない';
                        propertiesToSend['レイアウト確認'] = confirmVal;
                        // Update JSON metadata for consistency
                        const jsonConfirmItem = Object.values(hiddenJSON).find(i => i.label === 'レイアウト確認');
                        if (jsonConfirmItem) {
                            jsonConfirmItem.value = confirmVal;
                            jsonConfirmItem._value = [confirmVal];
                        }
                    }

                    // File Upload Name & URL
                    const myFileForCheck = this.container.querySelector('input[name="properties[入稿ファイル名]"]');
                    const myFileUrlInput = this.container.querySelector('#rf-file-urls');

                    const finalFName = myFileForCheck?.value || "なし";
                    const finalFUrl = myFileUrlInput?.value || "";

                    // Google Drive Integration & Admin Link Support
                    // REVISED: Unification to "ファイルアップロード" (Visible) only.

                    if (finalFUrl) {
                        // A. Clean URL for internal use (GAS / Thumbnails)
                        // Remove quotes if present
                        const cleanUrl = finalFUrl.replace(/['"]+/g, '');

                        // Visible Property: Admin UI
                        // User requested Split Properties: "ファイルアップロード1", "ファイルアップロード2"...

                        const urlList = cleanUrl.split(',').map(u => u.trim()).filter(u => u);
                        if (urlList.length === 1) {
                            // If only 1 file, keep simple "ファイルアップロード" (or "1" if preferred? User showed "1" in list)
                            // The request showed logic for multiple. 
                            // Let's stick to "ファイルアップロード" for single, and numbered for multiple?
                            // "変更後: ファイルアップロード1..." implies strictly numbered.
                            // Let's use numbered always for consistency with the request.
                            propertiesToSend['ファイルアップロード1'] = urlList[0];
                        } else {
                            urlList.forEach((u, i) => {
                                propertiesToSend[`ファイルアップロード${i + 1}`] = u;
                            });
                        }
                        // Remove the old aggregate key
                        delete propertiesToSend['ファイルアップロード'];
                    }

                    // C. Explicitly Delete Duplicate/Fluctuating Keys
                    delete propertiesToSend['入稿データURL'];
                    delete propertiesToSend['入稿ファイル情報'];
                    delete propertiesToSend['_入稿データURL']; // Strict Removal per Request

                    // Aggressive Cleanup: Remove any other key that looks like a URL duplicate
                    Object.keys(propertiesToSend).forEach(k => {
                        // Allow "ファイルアップロード" or "ファイルアップロード1", "2"...
                        const isAllowed = k === 'ファイルアップロード' || k.match(/^ファイルアップロード\d+$/);

                        if ((k.includes('入稿データURL') || k.includes('ファイルアップロード')) && !isAllowed) {
                            delete propertiesToSend[k];
                        }
                    });


                    // Update hidden JSON metadata
                    const jsonFileItem = Object.values(hiddenJSON).find(i => i.label && (i.label.includes('ファイルアップロード') || i.label.includes('入稿')));
                    if (jsonFileItem) {
                        jsonFileItem.value = finalFName;
                        jsonFileItem._value = [finalFName];
                    }

                    // --- CRITICAL FIX 3: PREVENT DOUBLE JSON ENCODING ---
                    // User reported values like "\"Value\"". This happens if we double-stringify or if hiddenJSON contained strings.
                    // We trust "safeSet" and manual assignments, but verify everything before send.

                    Object.keys(propertiesToSend).forEach(key => {
                        let val = propertiesToSend[key];

                        // 1. If it's an array, join it (Standardize to comma-separated string)
                        if (Array.isArray(val)) {
                            propertiesToSend[key] = val.join(', ');
                        }
                        // 2. If it's a string looking like a JSON string ("..."), try to unwrap it
                        else if (typeof val === 'string') {
                            // Check if it looks like a JSON stringified string
                            if (val.startsWith('"') && val.endsWith('"')) {
                                try {
                                    const parsed = JSON.parse(val);
                                    // If parsing gives us a logical value (string/number), use it
                                    if (typeof parsed === 'string' || typeof parsed === 'number') {
                                        propertiesToSend[key] = parsed;
                                    }
                                } catch (e) {
                                    // Not valid JSON, keep original
                                }
                            }
                        }
                    });

                    // --- CRITICAL FIX 2: FORCE COLLECT Custom UI Properties via DOM ---
                    // FormData sometimes misses dynamic inputs or those with complex visibility. 
                    // We manually grab known critical keys to be 100% sure.

                    const safeSet = (key, val) => {
                        // [Fix] Ensure we don't accidentally stringify arrays or objects here
                        if (val === undefined || val === null) return;

                        let finalVal = val;
                        if (Array.isArray(val)) {
                            finalVal = val.join(', ');
                        } else if (typeof val === 'object') {
                            // Should not happen for simple props, but just in case
                            // If it's an object, we might want to keep it or stringify it?
                            // User wants Clean Strings.
                            // Assuming simple toString or avoid objects.
                            return; // Skip complex objects for "safeSet"
                        }

                        if (finalVal.toString().trim() !== "") {
                            propertiesToSend[key] = finalVal;
                        }
                    };

                    // 1. Size
                    const sizeMode = document.querySelector('input[name="rf-size-mode"]:checked')?.value;
                    if (sizeMode === 'standard') {
                        safeSet('印刷サイズ', this.elements.sizeSelect.value);
                    } else if (sizeMode === 'custom') {
                        const shorts = this.container.querySelector('#rf-size-short').value;
                        const longs = this.container.querySelector('#rf-size-long').value;
                        if (shorts && longs) safeSet('印刷サイズ', `定形外サイズ: ${shorts}x${longs}mm`);
                    }

                    // 2. Layout
                    const layout = document.querySelector('input[name="properties[印刷レイアウト]"]:checked')?.value;
                    safeSet('印刷レイアウト', layout);

                    // 3. Layout Options
                    if (layout === 'フチなし') {
                        const blCheck = this.container.querySelector('#rf-check-borderless');
                        if (blCheck && blCheck.checked) safeSet('画像の周囲が数mmカットされることを了承しました', '了承');
                    }
                    if (layout === 'フチあり') {
                        const marginType = document.querySelector('input[name="properties[フチ処理]"]:checked')?.value;
                        safeSet('フチ処理', marginType);

                        // Margin Details
                        // Margin Details
                        if (marginType === 'フチ幅指定') {
                            // REVISED logic: Unified "フチ幅" string, removal of individual keys.
                            // Format: "フチ幅: 上XXmm, 下XXmm..."
                            // Empty = "指定なし", 0 = "0mm"

                            const mTop = this.container.querySelector('#rf-margin-top').value;
                            const mBottom = this.container.querySelector('#rf-margin-bottom').value;
                            const mLeft = this.container.querySelector('#rf-margin-left').value;
                            const mRight = this.container.querySelector('#rf-margin-right').value;

                            const formatM = (v) => (v === "" || v === undefined) ? "指定なし" : v + "mm";

                            const tStr = `上${formatM(mTop)}`;
                            const bStr = `下${formatM(mBottom)}`;
                            const lStr = `左${formatM(mLeft)}`;
                            const rStr = `右${formatM(mRight)}`;

                            safeSet('フチ幅', `${tStr}, ${bStr}, ${lStr}, ${rStr}`);

                            // Explicitly remove individual property keys to prevent duplication in Cart
                            // (In case logic elsewhere or formData picked them up)
                            if (propertiesToSend['フチ幅(上)']) delete propertiesToSend['フチ幅(上)'];
                            if (propertiesToSend['フチ幅(下)']) delete propertiesToSend['フチ幅(下)'];
                            if (propertiesToSend['フチ幅(左)']) delete propertiesToSend['フチ幅(左)'];
                            if (propertiesToSend['フチ幅(右)']) delete propertiesToSend['フチ幅(右)'];

                        } else if (marginType === '画像サイズ指定') {
                            const mSize = document.querySelector('input[name="properties[画像サイズ]"]')?.value;
                            if (mSize) safeSet('画像サイズ', mSize);
                        }
                    }
                    if (layout === '完全データ入稿') {
                        const dCheck1 = this.container.querySelector('#rf-check-data-no-resize');
                        if (dCheck1 && dCheck1.checked) safeSet('データそのまま印刷了承', '了承');

                        const dCheck2 = this.container.querySelector('#rf-check-data-margin');
                        if (dCheck2 && dCheck2.checked) safeSet('完全データ余白3mm了承', '了承');
                    }

                    // 4. Common Options
                    const confirmCheck = this.container.querySelector('input[name="properties[レイアウト確認]"]:checked');
                    if (confirmCheck) safeSet('レイアウト確認', '希望する');

                    const remarks = document.querySelector('textarea[name="properties[データに関する備考]"]')?.value;
                    if (remarks) safeSet('データに関する備考', remarks);

                    // [NEW] Frame Color
                    const selectedColorInput = document.querySelector('input[name="properties[フレームカラー]"]:checked, input[name="properties[側面カラー]"]:checked, input[name="properties[テープカラー]"]:checked, input[name="properties[側面テープカラー]"]:checked');
                    if (selectedColorInput) {
                        const attrName = selectedColorInput.name.match(/\[(.*?)\]/)[1];
                        safeSet(attrName, selectedColorInput.value);
                    }

                    // [NEW] Mat Color
                    const matColor = document.querySelector('input[name="properties[マットカラー]"]:checked')?.value;
                    if (matColor) safeSet('マットカラー', matColor);

                    // [NEW] Paper Type & Size
                    const paperType = this.container.querySelector('#rf-paper-select')?.value;
                    if (paperType) safeSet('用紙種類', paperType);

                    const paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
                    if (paperSizeSelect && paperSizeSelect.value) {
                        const selectedOption = paperSizeSelect.options[paperSizeSelect.selectedIndex];
                        safeSet('用紙サイズ', selectedOption.value);
                    }

                    // [NEW] Window Size
                    const winShort = this.container.querySelector('#rf-window-short')?.value;
                    const winLong = this.container.querySelector('#rf-window-long')?.value;
                    if (winShort && winLong) safeSet('窓抜きサイズ', `${winShort}x${winLong}mm`);


                    // --- Merge remaining FormData (for safety) ---
                    for (let [key, val] of formData.entries()) {
                        if (key.startsWith('properties[')) {
                            const match = key.match(/properties\[(.*?)\]/);
                            if (match && match[1]) {
                                const label = match[1];
                                if (label.startsWith('_') || label === 'acpa_id') continue;
                                if (!propertiesToSend[label]) { // Only add if not already manually set
                                    if (val && val.toString().trim() !== "") {
                                        propertiesToSend[label] = val;
                                    }
                                }
                            }
                        }
                    }

                    // --- Final Cleanup to prevent fluctuation ---
                    delete propertiesToSend['入稿データURL'];
                    delete propertiesToSend['入稿ファイル情報'];

                    // CLEANUP: If Standard Mode, prevent custom dimensions from persisting in Cart
                    if (sizeMode === 'standard') {
                        if (propertiesToSend['縦(mm)']) delete propertiesToSend['縦(mm)'];
                        if (propertiesToSend['横(mm)']) delete propertiesToSend['横(mm)'];
                    }

                    // [FIX #P30542] Cleanup Image Size inputs if not relevant
                    // Only keep them if layout is 'フチあり' AND marginType is '画像サイズ指定'
                    const currentLayout = document.querySelector('input[name="properties[印刷レイアウト]"]:checked')?.value;
                    const currentMarginType = document.querySelector('input[name="properties[フチ処理]"]:checked')?.value;

                    if (currentLayout !== 'フチあり' || currentMarginType !== '画像サイズ指定') {
                        if (propertiesToSend['画像サイズ(横)']) delete propertiesToSend['画像サイズ(横)'];
                        if (propertiesToSend['画像サイズ(縦)']) delete propertiesToSend['画像サイズ(縦)'];
                    }

                    // --- Test Print Item Properties ---
                    if (this.elements.testPrintCheck && this.elements.testPrintCheck.checked && this.testPrintVariantId) {
                        const tpQty = parseInt(this.elements.testPrintQtyInput.value) || 1;

                        // REVISED: Dynamic Filename Collection
                        const tpFilename = Array.from(this.container.querySelectorAll(''))
                            .map(inp => inp.value)
                            .filter(v => v && v.trim() !== '')
                            .join(', ') || "指定なし";

                        const tpAddress = this.elements.testPrintAddress.value;

                        // Append properties for the main product indicating test print details
                        safeSet('テストプリントファイル名', tpFilename);
                        safeSet('テストプリント送付先住所', tpAddress);
                        safeSet('テストプリント数量', tpQty);

                        // If the theme/Shopify setup supports adding multiple items via form submission,
                        // we would need to create a separate set of inputs for the test print product.
                        // For now, we'll add its properties to the main product's properties.
                        // If a separate line item is desired, this would require an AJAX cart API call.
                        // Given the current structure, we'll attach test print details as properties to the main item.
                    }


                    // --- CRITICAL FIX 3: SYNC TO ACO HIDDEN JSON ---
                    // Some themes/apps ignore standard properties if Aco is active.
                    // We inject our custom properties into Aco's hidden storage to force them to persist.
                    const timestamp = Date.now();
                    let counter = 0;

                    for (const [key, val] of Object.entries(propertiesToSend)) {
                        // Using loop to catch everything collected by safeSet
                        // [FIX] Allow custom underscore properties (like _ダウンロード) to be added to hiddenJSON so Aco preserves them
                        if (key === '_acpaHidden' || key === '_acoCompatibility' || key === '_acoValidationDone') continue;

                        // Check if this label already exists in hiddenJSON
                        let existingKey = Object.keys(hiddenJSON).find(k => hiddenJSON[k].label === key);

                        if (existingKey) {
                            hiddenJSON[existingKey].value = val;
                            hiddenJSON[existingKey]._value = [val];
                        } else {
                            // Create new entry mimicking Aco structure
                            const newKey = `custom_${timestamp}_${counter++}`;
                            hiddenJSON[newKey] = {
                                label: key,
                                value: val,
                                _value: [val],
                                type: 'text'
                            };
                        }
                        // Also sync to compatibility map
                        acoCompatibility[key] = val;
                    }

                    // Update the JSON strings
                    const finalAcpaHidden = JSON.stringify(hiddenJSON);
                    const finalAcoCompatibility = JSON.stringify(acoCompatibility);

                    // Add Aco Hidden Fields to properties
                    propertiesToSend['_acpaHidden'] = finalAcpaHidden;
                    propertiesToSend['_acoCompatibility'] = finalAcoCompatibility;
                    propertiesToSend['_acoValidationDone'] = 'true';

                    // --- CRITICAL: Reorder Properties for Admin/Cart Display ---
                    const orderList = [
                        '印刷サイズ',
                        '縦(mm)', '横(mm)',
                        '印刷レイアウト',
                        'フチ処理',
                        'フチ幅',
                        '画像サイズ(横)', '画像サイズ(縦)',
                        '画像の周囲が数mmカットされることを了承しました',
                        'データそのまま印刷了承', '完全データ余白3mm了承',
                        'レイアウト確認',
                        'フレームカラー', // [NEW]
                        '側面カラー',
                        'テープカラー',
                        '側面テープカラー',
                        'マットカラー', // [NEW]
                        '用紙種類', // [NEW]
                        '用紙サイズ', // [NEW]
                        '窓抜きサイズ', // [NEW]
                        'テストプリント',
                        'テストプリント数量', 'テストプリントファイル名', 'テストプリント送付先住所',
                        '入稿ファイル名',
                        'データに関する備考',
                        '備考欄',
                        'ファイルアップロード'
                    ];

                    const orderedProps = {};
                    // 1. Add keys in preferred order
                    orderList.forEach(key => {
                        if (Object.prototype.hasOwnProperty.call(propertiesToSend, key)) {
                            orderedProps[key] = propertiesToSend[key];
                            delete propertiesToSend[key];
                        }
                    });
                    // 2. Add remaining keys (including hidden _acpaHidden etc.)
                    Object.keys(propertiesToSend).forEach(key => {
                        orderedProps[key] = propertiesToSend[key];
                    });

                    // --- Construct Items for AJAX Submission ---
                    const items = [];
                    const mainVariantId = this.container.closest('form').querySelector('input[name="id"]').value;
                    const bundleId = `bundle_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
                    orderedProps['_bundle_id'] = bundleId;
                    orderedProps['_bundle_type'] = 'main'; // [NEW] Identify as Parent

                    items.push({
                        id: parseInt(mainVariantId),
                        quantity: parseInt(this.elements.qtyInput.value) || 1,
                        properties: orderedProps
                    });

                    // [NEW] Add Paper Variant if selected (for Overmat/Bookmat)
                    const paperSelect = this.container.querySelector('#rf-paper-size-select');
                    if (paperSelect && paperSelect.value && !paperSelect.closest('.rf-hidden')) {
                        // Assuming value is Variant ID or we need to find it?
                        // If value is name, we need to map to ID.
                        // But Implementation Plan v2 said "Inject Paper Variant data".
                        // Let's assume for now paperSelect.value MIGHT be the ID if setup correctly, 
                        // OR we need to find the ID from rfConfig.paperData based on name.
                        // Let's grab the ID from the selected option's dataset if available.
                        const selectedOption = paperSelect.options[paperSelect.selectedIndex];
                        const paperVariantId = selectedOption.dataset.id || paperSelect.value;

                        if (paperVariantId && !isNaN(parseInt(paperVariantId))) {
                            items.push({
                                id: parseInt(paperVariantId),
                                quantity: parseInt(this.elements.qtyInput.value) || 1,
                                properties: {
                                    '_bundle_id': bundleId,
                                    'Main Product': this.productData.title,
                                    'Paper Size': selectedOption.text
                                }
                            });
                            console.log("RF: Added Paper Bundle Item", paperVariantId);
                        }
                    }

                    // Test Print Item
                    if (this.elements.testPrintCheck && this.elements.testPrintCheck.checked && this.testPrintVariantId) {
                        items.push({
                            id: parseInt(this.testPrintVariantId),
                            quantity: parseInt(this.elements.testPrintQtyInput.value) || 1,
                            properties: {
                                "_RelatedProduct": "Test Print",
                                "main_product": this.productData.title || "Main Product",
                                "_bundle_id": bundleId,
                                "ファイル名": Array.from(this.container.querySelectorAll(''))
                                    .map(inp => inp.value)
                                    .filter(v => v && v.trim() !== '')
                                    .join(', ') || "指定なし",
                                "送付先住所": this.elements.testPrintAddress.value
                            }
                        });
                    }

                    // Prepare Payload (renamed to avoid conflict)
                    const cartPayload = { items: items };

                    // [FIX] Detect Cart Drawer Section ID
                    const drawerEl = document.querySelector('cart-drawer');
                    let drawerSectionId = null;
                    if (drawerEl) {
                        const sectionContainer = drawerEl.closest('.shopify-section');
                        if (sectionContainer) {
                            drawerSectionId = sectionContainer.id.replace('shopify-section-', '');
                            cartPayload.sections = drawerSectionId;
                            cartPayload.sections_url = window.location.pathname;
                        }
                    }

                    // Execute AJAX Request
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(cartPayload)
                    })
                        .then(async response => {
                            const data = await response.json();

                            this.isSubmitting = false; // Always reset first

                            // Reset Button
                            if (btn) {
                                btn.textContent = 'カートに入れる';
                                btn.disabled = false;
                            }

                            if (data.status === 422) {
                                console.error("🛒 RF: Cart Add Error", data);
                                alert("カートへの追加に失敗しました。\n" + (data.description || "必須項目を確認してください。"));
                                return;
                            }

                            console.log("🛒 RF: Added to Cart via AJAX", data);

                            // [FIX] Wrapper Injection for Theme Compatibility
                            if (cartPayload.sections && data.sections && data.sections[cartPayload.sections]) {
                                const sectionId = cartPayload.sections;
                                const innerHTML = data.sections[sectionId];
                                const wrappedHTML = `<div id="shopify-section-${sectionId}" class="shopify-section">${innerHTML}</div>`;
                                data.sections[sectionId] = wrappedHTML;
                            }

                            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                                bubbles: true,
                                detail: {
                                    baseEvent: 'variant:add',
                                    cart: data
                                }
                            }));

                            // 3. Force Open Drawer
                            if (drawerEl) {
                                console.log("🛒 RF: Opening Cart Drawer");
                                if (typeof drawerEl.show === 'function') drawerEl.show();
                                else if (typeof drawerEl.open === 'function') drawerEl.open();
                                else drawerEl.setAttribute('open', 'true');
                            } else {
                                window.location.href = '/cart';
                            }
                        })
                        .catch(error => {
                            console.error('RF: AJAX Error', error);
                            this.isSubmitting = false; // Always reset first
                            if (btn) {
                                btn.textContent = 'カートに入れる';
                                btn.disabled = false;
                            }
                            alert("通信エラーが発生しました。");
                        });

                } catch (err) {
                    console.error('❌ RF: Logic error', err);
                    alert("エラーが発生しました。");
                    this.isSubmitting = false; // Reset
                    if (btn) {
                        btn.textContent = 'カートに入れる';
                        btn.disabled = false;
                    }
                }
            }, 300); // Short delay to ensure UI updates
        }



        // ... (handleSizeSelectChange unchanged)

        // ... (updateCustomCalculation unchanged)

        // ... (updateMainVariantId unchanged)

        /**
         * [NEW #P30328] レイアウト確認チェック時に納期テキストを動的変更
         * チェックON: 「ご入金・レイアウト確認完了後」
         * チェックOFF: 「ご入金・データチェック完了後」
         */
        updateShippingPrefixText() {
            const prefixEl = this.container.querySelector('#rf-shipping-prefix');
            if (!prefixEl) return;

            const layoutConfirmCheck = (this.container && typeof this.container.querySelector === 'function')
                ? this.container.querySelector('input[name="properties[レイアウト確認]"]:checked')
                : null;
            if (layoutConfirmCheck) {
                prefixEl.textContent = 'ご入金・レイアウト確認完了後';
            } else {
                prefixEl.textContent = 'ご入金・データチェック完了後';
            }
        }

        updateTotalDisplay() {
            let oneItemTotal = this.currentBasePrice;

            // [FIX] Add Paper Price
            let paperPrice = 0;
            const paperMode = document.querySelector('input[name="rf-paper-size-mode"]:checked')?.value;

            if (paperMode === 'custom') {
                // Custom: Use the matched variant price
                if (this.selectedPaperCustomVariant && this.selectedPaperCustomVariant.price) {
                    paperPrice = this.selectedPaperCustomVariant.price;
                }
            } else {
                // Standard: Use selected option data-price
                const paperSelect = this.container.querySelector('#rf-paper-size-select');
                if (paperSelect && paperSelect.selectedOptions && paperSelect.selectedOptions.length > 0) {
                    const selectedOpt = paperSelect.selectedOptions[0];
                    const p = selectedOpt.dataset.price;
                    if (p) paperPrice = parseInt(p, 10);
                }
            }

            // [NEW] updateAvailableColors if size is selected (Standard mode only?)
            // Actually, handleSizeSelectChange is where we should call it.
            // But for initial load update, let's check sizeSelect value.
            const sizeMode = document.querySelector('input[name="rf-size-mode"]:checked')?.value;

            // This method (updateTotalDisplay) is called frequently. calling updateAvailableColors here might be redundent or safe.
            // Ideally, updateAvailableColors is called only when SIZE changes. 
            // But let's verify if we need it here.


            // Add to Base Price
            oneItemTotal += paperPrice;

            const qty = parseInt(this.elements.qtyInput.value) || 1;
            let total = oneItemTotal * qty;

            // --- Test Print Calculation ---
            let testPrintTotal = 0;
            if (this.elements.testPrintCheck && this.elements.testPrintCheck.checked) {
                const tpQty = parseInt(this.elements.testPrintQtyInput.value) || 1;
                testPrintTotal = (this.testPrintPrice || 0) * tpQty;
            }

            // --- Volume Discount Logic ---
            let discountRate = 0;
            if (qty >= 100) discountRate = 0.15;
            else if (qty >= 50) discountRate = 0.13;
            else if (qty >= 30) discountRate = 0.12;
            else if (qty >= 10) discountRate = 0.10;

            let finalTotal = total; // Base total for main item
            if (discountRate > 0) {
                finalTotal = Math.floor(total * (1 - discountRate));
            }
            finalTotal += testPrintTotal; // Add test print total after main item discount

            if (this.currentBasePrice === 0 && testPrintTotal === 0) {
                const priceEl = this.container.querySelector('#rf-total-price') || this.container.querySelector('#rf-total-amount');
                if (priceEl) {
                    priceEl.textContent = "---";
                } else {
                    console.warn("RF: Price element not found (--- state)");
                }
            } else {
                // Display Logic
                const priceEl = this.container.querySelector('#rf-total-price') || this.container.querySelector('#rf-total-amount');

                // Date Element (User Request)
                const dateEl = this.container.querySelector('#rf-delivery-date');
                if (dateEl) {
                    // If we had date logic here, we'd use it. 
                    // Currently handled by lead-time.js? 
                    // Only LeadTimeCalculator knows the date.
                    // We leave this hook as requested.
                }

                if (priceEl) {
                    if (discountRate > 0) {
                        const originalTotal = oneItemTotal * qty;
                        const discountPercent = Math.round(discountRate * 100);

                        priceEl.innerHTML = `
                    <div class="rf-price-wrapper">
                            <div class="rf-discount-group">
                                <span class="rf-discount-tag">${discountPercent}% OFF</span>
                                <span class="rf-original-price">${this.formatCurrency(originalTotal)}</span>
                            </div>
                            <span class="rf-final-price">${this.formatCurrency(finalTotal)}</span>
                    </div>
                    `;
                    } else {
                        priceEl.textContent = this.formatCurrency(finalTotal);
                    }
                } else {
                    console.warn("RF: Price element not found for update!");
                }
            }

            // [NEW] Sync Visual State
            this.updateVisualState();
        }

        // [NEW] Global Visual State Sync (Ensures .active is always correct)
        // [NEW] Global Visual State Sync (Ensures .active is always correct)
        updateVisualState() {
            const root = this.elements?.form || this.container || document;
            // Find all radio inputs in the form
            const radios = (root && typeof root.querySelectorAll === 'function')
                ? root.querySelectorAll('input[type="radio"]')
                : [];
            let checkedCount = 0;
            if (radios.forEach) {
                radios.forEach(radio => {
                    // Find parent card or pill
                    const parent = (typeof radio.closest === 'function') ? radio.closest('.rf-radio-card, .rf-radio-pill, label') : null;
                    if (parent && parent.classList && typeof parent.classList.add === 'function') {
                        if (radio.checked) {
                            parent.classList.add('active');
                            checkedCount++;
                            // DEBUG
                            // console.log(`RF: Active Radio Found: ${radio.name} = ${radio.value}`);
                        } else {
                            parent.classList.remove('active');
                        }
                    }
                });
            }
            // console.log(`RF: Visual State Updated. Checked Radios: ${checkedCount}`);
        }


        handleSubmit(e) {
            console.log("📝 RF: handleSubmit triggered (Form Submit Event)");
            if (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
            this.handleRobustSubmit(e);
            return false;
        }

        // ... (formatCurrency unchanged)

        // ... (handleLayoutChange logic already updated in thought but code might not be replaced?)
        // Ah, previous chunk was partial. I need to make sure handleLayoutChange logic is actually replaced.
        // The previous tool call modified the constructor and checkInitialLayout.
        // The tool call before that modified handleLayoutChange logic.
        // Let's ensure handleSubmit is updated here.

        validateForm() {
            console.log("RF: Validating form...");
            let isValid = true;
            let firstErrorEl = null;

            const registerError = (el, msg = "") => {
                console.warn("RF Validation Failure:", msg, el);
                this.showError(el);
                isValid = false;
                // Prefer the label or container for scrolling context if possible
                const scrollTarget = el.closest('.rf-section') || el.closest('.rf-input-group') || el;
                if (!firstErrorEl) firstErrorEl = scrollTarget;
            };

            const mode = document.querySelector('input[name="rf-size-mode"]:checked')?.value;
            console.log("RF Validation: Size Mode =", mode);

            // Custom Size Validation
            if (mode === 'standard' && this.elements.sizeSelect.value === '' && this.formType !== 'student_discount') {
                registerError(this.elements.sizeSelect, "Standard Size Empty");
            }
            if (mode === 'custom') {
                if (!this.elements.customShort.value) { registerError(this.elements.customShort, "Custom Short Empty"); }
                if (!this.elements.customLong.value) { registerError(this.elements.customLong, "Custom Long Empty"); }
                if (this.currentBasePrice === 0) {
                    // If price is 0 but inputs are filled, it's an invalid size combo
                    if (this.elements.customShort.value && this.elements.customLong.value) {
                        registerError(this.elements.customDisplay, "Price is 0 (Invalid Size)");
                    }
                }
            }

            // Frame Color Validation
            // [FIX] ID 16: Mandatory Frame Color
            const colorSection = this.container.querySelector('#rf-section-color');
            if (colorSection && colorSection.style.display !== 'none' && !colorSection.classList.contains('rf-content-hidden')) {
                const colorInputs = colorSection.querySelectorAll('input[name="properties[フレームカラー]"], input[name="properties[側面カラー]"], input[name="properties[テープカラー]"], input[name="properties[側面テープカラー]"]');
                if (colorInputs.length > 0) {
                    const colorChecked = Array.from(colorInputs).some(inp => inp.checked);
                    if (!colorChecked) {
                        console.warn("RF Validation Failure: No Frame Color Selected");
                        isValid = false;

                        // Highlight
                        const colorGroup = colorSection.querySelector('.rf-image-group');
                        if (colorGroup) {
                            colorGroup.classList.add('rf-shake');
                            setTimeout(() => colorGroup.classList.remove('rf-shake'), 500);
                            // Add red border to images? Or just shake.
                        }
                        if (!firstErrorEl) firstErrorEl = colorSection;
                    }
                }
            }

            // Layout Validation
            const layoutSection = this.container.querySelector('#rf-section-layout');
            if (layoutSection && layoutSection.style.display !== 'none' && !layoutSection.classList.contains('rf-content-hidden')) {
                let layout = null;
                // Search globally or within container for ANY checked input with this name
                const layoutInputs = document.querySelectorAll('input[name="properties[印刷レイアウト]"]');
                layoutInputs.forEach(inp => {
                    if (inp.checked) layout = inp.value;
                });

                console.log("RF Validation: Layout =", layout);

                if (!layout) {
                    // Visual Error Handling
                    layoutInputs.forEach(inp => {
                        const card = inp.closest('.rf-radio-card');
                        if (card) {
                            card.style.borderColor = 'var(--rf-error)';
                            setTimeout(() => card.style.borderColor = '', 1500);
                        }
                    });

                    isValid = false;
                    // Try to find a scroll target
                    if (!firstErrorEl) firstErrorEl = this.container.querySelector('#rf-section-layout');
                    console.warn("RF Validation Failure: No Layout Selected");
                }

                // Borderless Permission Validation
                if (layout === 'フチなし') {
                    const borderCheck = this.container.querySelector('#rf-check-borderless');
                    if (borderCheck && !borderCheck.checked) {
                        registerError(document.querySelector('label[for="rf-check-borderless"]'), "Borderless Check Missing");
                    }
                }

                // Complete Data Submission Validation
                if (layout === '完全データ入稿') {
                    const checkNoResize = this.container.querySelector('#rf-check-data-no-resize');
                    const checkMargin = this.container.querySelector('#rf-check-data-margin');

                    if (checkNoResize && !checkNoResize.checked) {
                        registerError(checkNoResize.closest('label'), "Data No Resize Check Missing");
                    }
                    if (checkMargin && !checkMargin.checked) {
                        registerError(checkMargin.closest('label'), "Data Margin Check Missing");
                    }
                }
            }

            // [FIX #P30544] Paper Type Validation (Mandatory for Print Only)
            const paperSection = this.container.querySelector('#rf-section-paper');
            if (paperSection && paperSection.style.display !== 'none' && !paperSection.classList.contains('rf-content-hidden')) {
                if (this.elements.paperSelect && (!this.elements.paperSelect.value || this.elements.paperSelect.disabled)) {
                    // Check if it's "loading" state? If disabled and loading, maybe we wait? 
                    // But user shouldn't submit.
                    registerError(this.elements.paperSelect, "Paper Type Not Selected");
                }
            }

            // [NEW] Trial Printing Validation
            if (this.formType === 'otameshi_print') {
                const trialConfirmWrapper = this.container.querySelector('#rf-section-trial-confirm');
                if (trialConfirmWrapper && trialConfirmWrapper.style.display !== 'none') {
                    const subCheck = this.container.querySelector('#rf-check-trial-confirm');
                    if (subCheck && !subCheck.checked) {
                        registerError(subCheck.closest('label'), "Trial Confirmation Missing");
                    }
                }
            }

            // [NEW] Student Discount Validation
            if (this.formType === 'student_discount') {
                if (this.uploadedFiles.length === 0) {
                    registerError(this.elements.dropzone, "Student ID Upload Missing");
                }
            }

            // [FIX] Canvas Panel Agreement Validation
            // 「制作上の注意点」セクションの必須チェックボックスを全チェック
            if (this.formType === 'canvas_panel') {
                const canvasAgreementSection = this.container.querySelector('#rf-section-canvas-agreement');
                if (canvasAgreementSection) {
                    const agreementChecks = canvasAgreementSection.querySelectorAll('input[type="checkbox"]');
                    agreementChecks.forEach(cb => {
                        if (!cb.checked) {
                            registerError(cb.closest('label') || cb, 'Canvas Agreement Not Checked');
                        }
                    });
                }
            }

            // [NEW] Margin Inputs Validation (Respect min attribute)
            const marginInputs = document.querySelectorAll('#rf-margin-width-inputs input[type="number"], #rf-margin-size-inputs input[type="number"]');
            marginInputs.forEach(inp => {
                // Check if visible
                if (inp.closest('.rf-sub-conditional') && inp.closest('.rf-sub-conditional').style.display !== 'none' && !inp.checkValidity()) {
                    registerError(inp, `Invalid Margin/Size: ${inp.validationMessage}`);
                }
            });

            // Test Print Validation (Disabled: Options are now optional)
            // Code removed to allow empty fields.

            if (!isValid && firstErrorEl) {
                console.log("RF: Validation Failed. Scrolling to error.");
                // Smooth scroll to the first error element
                firstErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                console.log("RF: Validation Passed!");
            }


            // [NEW] Photo Card Validation: File Count vs Order Qty
            if (this.formType === 'photo_card') {
                const uploadedCount = this.uploadedFiles.length;
                const orderQty = parseInt(this.elements.qtyInput.value) || 1;

                // Only validate if files are uploaded (if 0, maybe valid if just test print? Assuming files required if not just test print)
                // But usually file upload optional? "File upload: Any".
                // Requirement said: "File count <= Order Qty".
                if (uploadedCount > orderQty) {
                    registerError(this.elements.dropzone, `アップロードファイル数(${uploadedCount})が注文総数(${orderQty})を超えています。`);
                    alert(`アップロードファイル数が注文数を超えています。\n・注文数: ${orderQty}枚\n・アップロード: ${uploadedCount}点\n\nファイルを確認するか、注文数を変更してください。`);
                }
            }

            // [NEW] Validate Glossy Warning Check (Unified)
            const glossyWarningSection = this.container.querySelector('#rf-section-glossy-warning');
            if (glossyWarningSection && !glossyWarningSection.classList.contains('rf-content-hidden') && glossyWarningSection.style.display !== 'none') {
                const glossyCheck = this.container.querySelector('#rf-check-glossy-agree');
                if (glossyCheck && !glossyCheck.checked) {
                    alert('光沢紙の特性について確認し、チェックを入れてください。');
                    glossyWarningSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return false;
                }
            }

            return isValid;
        }



        updateQuantity(delta) {
            let current = parseInt(this.elements.qtyInput.value) || 1;
            current += delta;
            if (current < 1) current = 1;
            this.elements.qtyInput.value = current;

            // Sync with main form quantity if exists
            const form = this.container.closest('form');
            if (form) {
                const mainQty = form.querySelector('input[name="quantity"]:not(#rf-qty-input)');
                if (mainQty) mainQty.value = current;
            }

            this.updateTotalDisplay();

            // Clear upload errors when quantity changes to allow re-trying upload
            this.elements.uploadError.style.display = 'none';
        }

        handleSimpleToggle(show, element) {
            if (!element) return;
            this.toggleContent(element, show);
        }

        updateTestPrintQty(delta) {
            const input = this.elements.testPrintQtyInput;
            if (!input) return;
            let val = parseInt(input.value) || 1;
            val += delta;
            if (val < 1) val = 1;
            input.value = val;

            // Dynamic Filename Inputs Logic
            const wrapper = this.container.querySelector('#rf-tp-filename-wrapper');
            if (wrapper) {
                let inputs = wrapper.querySelectorAll('.rf-tp-file-input');
                let currentCount = inputs.length;

                if (val > currentCount) {
                    for (let i = currentCount + 1; i <= val; i++) {
                        const newInp = document.createElement('input');
                        newInp.type = 'text';
                        newInp.className = 'rf-input rf-tp-file-input';
                        newInp.placeholder = `例: photo_0${i}.jpg (${i}枚目)`;
                        newInp.style.marginBottom = '10px';
                        wrapper.appendChild(newInp);
                    }
                } else if (val < currentCount) {
                    for (let i = currentCount; i > val; i--) {
                        if (wrapper.lastElementChild) {
                            wrapper.removeChild(wrapper.lastElementChild);
                        }
                    }
                }
            }

            this.updateTotalDisplay();
        }

        handleSizeModeChange(e) {
            const mode = e.target.value;
            const isStandard = mode === 'standard';

            if (isStandard) {
                this.elements.standardContainer.style.display = 'block';
                this.elements.customContainer.style.display = 'none';
                this.handleSizeSelectChange({ target: this.elements.sizeSelect });
            } else {
                this.elements.standardContainer.style.display = 'none';
                this.elements.customContainer.style.display = 'block';

                if (this.elements.customShort.value && this.elements.customLong.value) {
                    this.updateCustomCalculation();
                } else {
                    this.currentBasePrice = 0;
                    this.updateTotalDisplay();
                }
                // [FIX] Update Color Options visibility for Custom Mode
                if (typeof this.updateFrameColorOptions === 'function') {
                    this.updateFrameColorOptions();
                }
            }

            // [NEW] Toggle standard size notes visibility
            // 定形外サイズの場合は「定形サイズでオーダー」「2枚納品の料金」注意書きを非表示
            const standardSizeNotes = this.container.querySelector('#rf-standard-size-notes');
            if (standardSizeNotes) {
                standardSizeNotes.style.display = isStandard ? 'block' : 'none';
            }

            this.updateVisualState(); // Add this line
        }

        handleSizeSelectChange(e) {
            // ▼▼▼ 修正ポイント: e.target ではなく、常に「保存してあるサイズ選択要素」を見に行く ▼▼▼
            const selectElement = this.elements.sizeSelect;

            if (!selectElement) return;

            const selectedOption = selectElement.options[selectElement.selectedIndex];

            // [NEW] Trial Printing: Check for "All Paper Set"
            if (this.formType === 'otameshi_print') {
                const trialConfirm = this.container.querySelector('#rf-section-trial-confirm');
                if (trialConfirm) {
                    const val = selectedOption ? selectedOption.value : "";
                    if (val && val.includes('【全用紙セット】')) {
                        trialConfirm.style.display = 'block';
                        const checkbox = trialConfirm.querySelector('input[type="checkbox"]');
                        if (checkbox) checkbox.checked = false;
                    } else {
                        trialConfirm.style.display = 'none';
                    }
                }
            }

            // サイズがまだ選択されていない、または空の場合はリセットして終了
            // (加工タイプを先に選んだ場合などはここで止まりますが、それは正常です)
            if (!selectedOption || selectedOption.value === "") {
                console.log("RF: No size selected yet.");
                this.currentBasePrice = 0;
                this.updateTotalDisplay();
                return;
            }

            // ▼ 検索ロジック (getMainVariantAndPrice) を呼び出す
            // ここで「現在のサイズ」と「現在の加工タイプ」を組み合わせて検索します
            const mainVariantInfo = this.getMainVariantAndPrice();

            const price = mainVariantInfo.price;
            const variantId = mainVariantInfo.id;

            console.log(`RF: Size/Type Changed. New Price: ${price}, ID: ${variantId}`);

            this.currentBasePrice = price;

            // [DPI計算用] 寸法情報の取得（変更なし）
            const text = selectedOption.textContent || "";
            let foundDim = null;
            if (typeof STANDARD_SIZE_DICT !== 'undefined') {
                for (const [key, val] of Object.entries(STANDARD_SIZE_DICT)) {
                    if (text.includes(key)) {
                        foundDim = val;
                        break;
                    }
                }
            } else if (this.STANDARD_SIZES) {
                foundDim = this.STANDARD_SIZES[selectedOption.value];
                if (!foundDim) {
                    for (const [key, val] of Object.entries(this.STANDARD_SIZES)) {
                        if (text.includes(key) || selectedOption.value === key) {
                            foundDim = val;
                            break;
                        }
                    }
                }
            }

            this.currentDimensions = foundDim || null;

            this.updateMainVariantId(variantId);
            this.updateTotalDisplay();

            // [NEW] Update Available Colors based on Size
            this.updateAvailableColors(selectedOption.value);

            // [NEW] Update Paper Options based on Size (filter by matching size)
            this.updatePaperTypeOptions();

            // ▼▼▼ 追加: サイズが変わったら用紙サイズ選択肢もフィルタリングし直す ▼▼▼
            if (typeof this.updatePaperSizeOptions === 'function') {
                this.updatePaperSizeOptions();
            }

            // [FIX] Trigger Paper Dropdown Filter for Standard Size
            if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                this.filterPaperDropdownByEffectiveSize();
            }
            // ▲▲▲ 追加ここまで ▲▲▲

            if (typeof this.updateAllDPIs === 'function') {
                this.updateAllDPIs();
            }
        }

        updateCustomCalculation() {
            const w = parseInt(this.elements.customShort.value) || 0;
            const h = parseInt(this.elements.customLong.value) || 0;

            // [NEW] Track Dimensions
            this.currentDimensions = (w > 0 && h > 0) ? [w, h] : null;

            this.updateAllDPIs(); // [NEW] Recalc DPI (Fix for Custom Size)

            if (w <= 0 || h <= 0) {
                if (this.elements.customDisplay) this.elements.customDisplay.textContent = "-- x -- mm";
                if (this.elements.priceDisplay) this.elements.priceDisplay.textContent = "--";
                this.currentBasePrice = 0;
                this.updateTotalDisplay();
                return;
            }

            const inputShort = Math.min(w, h);
            const inputLong = Math.max(w, h);

            // Dynamic Matching Logic
            let bestMatch = null;

            // [NEW] Photo Card Logic: Filter by Layout (Option 2)
            let requiredOption2 = null;
            if (this.formType === 'photo_card') {
                const layoutRadio = this.container.querySelector('input[name="properties[印刷レイアウト]"]:checked');
                if (layoutRadio) requiredOption2 = layoutRadio.value; // "フチなし" or "フチあり"
            }

            // 1. Exact Match First
            for (const size of this.availableSizes) {
                if (Math.abs(size.short - inputShort) < 2 && Math.abs(size.long - inputLong) < 2) {
                    // If Photo Card, check Option 2
                    if (requiredOption2) {
                        // Check exact match on Option 2
                        // Note: option2 might be undefined if not captured (fixed in parseProductSizes)
                        if (size.options && size.options[1] === requiredOption2) {
                            bestMatch = size;
                            break;
                        }
                    } else {
                        bestMatch = size;
                        break;
                    }
                }
            }

            // 2. Smallest Fit Second (Only if exact match failed)
            if (!bestMatch) {
                // ... existing fit logic but maybe irrelevant for standard sizes?
                // Actually standard sizes usually hit Exact Match.
                // This fallback is for loose matching. 
                // We should apply the same Option 2 filter here.

                for (const size of this.availableSizes) {
                    if (size.short >= inputShort && size.long >= inputLong) {
                        if (requiredOption2) {
                            if (size.options && size.options[1] === requiredOption2) {
                                bestMatch = size;
                                break;
                            }
                        } else {
                            bestMatch = size;
                            break;
                        }
                    }
                }
            }

            if (bestMatch) {
                if (this.elements.customDisplay) this.elements.customDisplay.textContent = `ご注文サイズ: ${bestMatch.name} `;
                this.currentBasePrice = bestMatch.price;
                if (this.elements.priceDisplay) this.elements.priceDisplay.textContent = this.formatCurrency(bestMatch.price);
                this.updateMainVariantId(bestMatch.id);

            } else {
                if (this.elements.customDisplay) this.elements.customDisplay.textContent = "対応サイズなし";
                const subject = encodeURIComponent("サイズ見積もり依頼");
                const prodName = (this.productData && this.productData.title) || window.rfConfig?.productTitle || "商品名不明";
                const body = encodeURIComponent(`【ご入力いただいた内容】\n商品名: ${prodName}\n希望サイズ: ${s}mm x ${l}mm`);
                if (this.elements.priceDisplay) this.elements.priceDisplay.innerHTML = `<a href="mailto:info@photopri.com?subject=${subject}&body=${body}" style="text-decoration:underline; color:inherit;">お問合せください</a>`;
                this.currentBasePrice = 0;
            }
            // Bind methods
            this.updateTotalDisplay = this.updateTotalDisplay.bind(this);
            this.validateFraming = this.validateFraming.bind(this);

            // [FIX] Trigger Paper Dropdown Filter for Custom Size
            if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                this.filterPaperDropdownByEffectiveSize();
            }
        }

        init() {
            if (!this.elements.form) return;
            this.initListeners();
            this.initFramingLogic(); // New Logic

            // Initial Calculation
            this.updateTotalDisplay();
            this.updateVisualState(); // Initial Visual Sync

            // [FIX] Initial Paper Filter Check
            if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                this.filterPaperDropdownByEffectiveSize();
            }
        }
        updateMainVariantId(id) {
            if (!id) return;
            const form = this.container.closest('form');
            if (form) {
                const idInput = form.querySelector('input[name="id"]');
                if (idInput) {
                    idInput.value = id;
                    idInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }




        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes';
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]} `;
        }

        formatCurrency(cents) {
            return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(cents / 100);
        }

        // [NEW] DPI Calculation Helper
        calculateDPI(imgW, imgH) {
            if (!this.currentDimensions || !imgW || !imgH) return null;
            const [printW, printH] = this.currentDimensions;

            // Match orientation (Long side to Long side) logic
            const printLong = Math.max(printW, printH);
            // const printShort = Math.min(printW, printH);
            const imgLong = Math.max(imgW, imgH);

            // inches = mm / 25.4
            const inchesLong = printLong / 25.4;

            if (inchesLong <= 0) return null;

            const dpi = Math.round(imgLong / inchesLong);
            return dpi;
        }

        // [NEW] Truncate Filename
        truncateFilename(name, maxLength = 20) {
            if (name.length <= maxLength) return name;
            // e.g. "very-long-filename...jpg"
            const extIndex = name.lastIndexOf('.');
            if (extIndex === -1) return name.slice(0, 10) + '...' + name.slice(-7);

            const ext = name.slice(extIndex); // .jpg
            const base = name.slice(0, extIndex);

            // simple strategy: keep start + end of base? 
            const remaining = maxLength - ext.length - 3; // 3 for '...'
            if (remaining < 2) return name.slice(0, 10) + '...' + name.slice(-7); // Fallback

            const part = Math.floor(remaining / 2);
            return base.slice(0, part) + '...' + base.slice(-part) + ext;
        }

        // [NEW] Update All DPIs on Size Change
        updateAllDPIs() {
            const items = this.elements.fileList.querySelectorAll('.rf-file-item');
            items.forEach(item => {
                const w = parseInt(item.dataset.w);
                const h = parseInt(item.dataset.h);
                const badge = item.querySelector('.rf-file-res-badge');

                if (w && h && badge) {
                    const dpi = this.calculateDPI(w, h);
                    let text = `解像度: ${w} x ${h} px`;
                    if (dpi) {
                        text += ` / <span>${dpi} dpi</span>`;
                        badge.style.color = '#666';
                    } else {
                        // If standard size deselected, DPI becomes null. Just show resolution.
                        badge.style.color = '#666';
                    }
                    badge.innerHTML = text;
                    badge.style.display = 'block';
                }
            });
        }

        // [NEW] Per-File Quantity Validation
        async validateTotalQuantity(changedInput, blocking = false) {
            if (this.formType === 'student_discount') return true; // [FIX] Skip quantity check for student discount

            const qtyInputs = this.elements.fileList.querySelectorAll('.rf-img-qty');
            let sum = 0;
            qtyInputs.forEach(input => sum += (parseInt(input.value) || 1));

            const mainQty = parseInt(this.elements.qtyInput.value) || 1;

            if (sum > mainQty) {
                const confirmed = await RFModal.confirm(
                    '数量の自動調整',
                    `画像の合計枚数(${sum}枚)が注文総数(${mainQty}枚)を超えています。<br>注文総数を ${sum} 枚に変更しますか？<br><small>※「キャンセル」を押すと、枚数を元に戻します。</small>`
                );

                if (confirmed) {
                    this.elements.qtyInput.value = sum;
                    this.updateQuantity(0); // Trigger updates
                    return true; // Resolved
                } else {
                    // Revert change
                    if (changedInput) {
                        const currentVal = parseInt(changedInput.value) || 1;
                        const overflow = sum - mainQty;
                        changedInput.value = Math.max(1, currentVal - overflow);
                    }
                    return false; // ValidState not achieved if blocking
                }
            }
            return true; // No issue
        }

        handleLayoutChange(e) {
            const selected = e.target;

            // Map values to Section IDs
            const map = {
                'フチあり': 'rf-section-margin',
                'フチなし': 'rf-section-borderless',
                '完全データ入稿': 'rf-section-data'
            };

            // 1. Hide ALL layout detail sections first (Default State)
            Object.values(map).forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    this.toggleContent(el, false);
                    const confirmCheck = el.querySelector('input[name="properties[レイアウト確認]"]');
                    if (confirmCheck) confirmCheck.checked = false;
                }
            });

            // 2. Reset specific inputs for ALL layout types
            const checkBorderless = this.container.querySelector('#rf-check-borderless');
            if (checkBorderless) checkBorderless.checked = false;

            // [FIX #P30328] Reset complete data entry checkboxes when switching layouts
            const checkDataNoResize = this.container.querySelector('#rf-check-data-no-resize');
            if (checkDataNoResize) checkDataNoResize.checked = false;

            const checkDataMargin = this.container.querySelector('#rf-check-data-margin');
            if (checkDataMargin) checkDataMargin.checked = false;

            const descContainer = this.container.querySelector('#rf-layout-desc-container');

            // If deselected (checked is false), Hide Everything and Return
            if (!selected.checked) {
                if (descContainer) {
                    // Hard reset to ensure text disappears immediately
                    descContainer.style.display = 'none';
                    descContainer.classList.remove('rf-open', 'rf-expandable');
                    const inner = descContainer.querySelector('.rf-expandable-inner');
                    if (inner) inner.innerHTML = '';
                }
                return;
            }

            const layoutType = selected.value;

            // 3. Show the relevant section
            const targetId = map[layoutType];
            if (targetId) {
                const targetEl = document.getElementById(targetId);
                if (targetEl) {
                    this.toggleContent(targetEl, true);
                    targetEl.classList.remove('rf-dimmed');
                }
            }

            // 4. Update Layout Description (Single Container)
            let descKey = '';
            if (layoutType === 'フチあり') descKey = 'border';
            if (layoutType === 'フチなし') descKey = 'borderless';
            if (layoutType === '完全データ入稿') descKey = 'data';

            if (descKey && descContainer) {
                const template = document.getElementById('rf-desc-' + descKey);
                if (template) {
                    const inner = descContainer.querySelector('.rf-expandable-inner');
                    if (inner) {
                        const content = template.innerHTML.trim();
                        if (!content) {
                            // [FIX] Hide if content is empty (e.g. wood_panel)
                            descContainer.style.display = 'none';
                            descContainer.classList.remove('rf-open', 'rf-expandable');
                            inner.innerHTML = '';
                        } else {
                            inner.innerHTML = template.innerHTML;
                            descContainer.style.display = '';
                            descContainer.classList.add('rf-expandable');
                            this.toggleContent(descContainer, true);
                        }
                    }
                }
            } else if (descContainer) {
                // Hard reset
                descContainer.style.display = 'none';
                descContainer.classList.remove('rf-open', 'rf-expandable');
                const inner = descContainer.querySelector('.rf-expandable-inner');
                if (inner) inner.innerHTML = '';
            }


            // [NEW] Trigger Variant Re-calculation if Layout affects Variant (e.g. Photo Card)
            if (this.formType === 'photo_card') {
                // Re-run size selection logic to pick correct variant based on new layout
                this.handleSizeSelectChange({ target: this.elements.sizeSelect });
            }
        }

        handleMarginTypeChange(e) {
            const val = e.target.value;
            this.toggleContent(this.elements.marginWidthInputs, val === 'フチ幅指定');
            this.toggleContent(this.elements.marginSizeInputs, val === '画像サイズ指定');
        }

        toggleContent(element, show) {
            // Legacy toggle kept for backward compat if needed, 
            // but prefer toggleContentSmooth for main sections if they have correct class.
            // For now, map simple toggle to smooth logic if we want to apply it globally?
            // Let's implement specific Smooth Logic.

            if (!element) return;

            if (show) {
                element.classList.remove('rf-content-hidden');
                element.style.display = 'block';
                element.style.height = 'auto'; // Reset explicit height
                element.style.opacity = '1';

                // Add 'rf-open' for expandable items
                if (element.classList && typeof element.classList.contains === 'function' && element.classList.contains('rf-expandable')) {
                    // minor delay to allow display:block to register for transition?
                    // actually grid transition works purely on class toggle if display is handled properly
                    if (typeof requestAnimationFrame === 'function') {
                        requestAnimationFrame(() => element.classList.add('rf-open'));
                    } else {
                        element.classList.add('rf-open');
                    }
                }
            } else {
                if (element.classList && typeof element.classList.contains === 'function' && element.classList.contains('rf-expandable')) {
                    element.classList.remove('rf-open');
                    // Wait for transition end to hide? No, grid handles it.
                } else {
                    if (element.style) {
                        element.style.display = 'none';
                        element.style.height = '0';
                        element.style.opacity = '0';
                    }
                    if (element.classList) element.classList.add('rf-content-hidden');
                }
            }
        }

        disableNumberScroll() {
            // [FIX] Robustly prevent scroll from changing number values
            // Listen on document to catch all inputs (even dynamic ones)
            // Use { passive: false } to allow preventDefault()
            document.addEventListener('wheel', (e) => {
                if (e.target.tagName === 'INPUT' && e.target.type === 'number') {
                    // Always prevent default value change
                    e.preventDefault();

                    // If focused, blur it to remove the "active" state that might confuse users
                    // trying to scroll the page.
                    if (document.activeElement === e.target) {
                        e.target.blur();
                    }
                }
            }, { passive: false });
        }

        async handleFiles(rawFiles) {
            // Create static array immediately because clearing input.value wipes the live FileList
            const files = Array.from(rawFiles);

            // Clear input to allow re-selecting same files
            if (this.elements.fileInput) this.elements.fileInput.value = '';

            console.log("handleFiles processing:", files);
            this.elements.uploadError.style.display = 'none';

            // Show Remarks Field
            const remarksGroup = this.container.querySelector('#rf-file-remarks-group');
            if (remarksGroup) remarksGroup.style.display = 'block';

            const currentQty = parseInt(this.elements.qtyInput.value) || 1;

            if (this.formType === 'student_discount') {
                if (this.uploadedFiles.length + files.length > 2) {
                    this.showError(this.elements.dropzone, `学割フォームでは最大2枚までしか画像をアップロードできません。`);
                    return;
                }
            } else {
                if (this.uploadedFiles.length + files.length > currentQty) {
                    const totalFiles = this.uploadedFiles.length + files.length;
                    const confirmed = await RFModal.confirm(
                        '数量の自動調整',
                        `アップロードされたファイル数が注文数を超えています。\n注文数を ${totalFiles} 枚に変更しますか？`
                    );

                    if (confirmed) {
                        this.elements.qtyInput.value = totalFiles;
                        this.updateQuantity(0); // Trigger update
                    } else {
                        this.showError(this.elements.dropzone, `注文数(${currentQty}枚)を超えるファイルはアップロードできません。`);
                        return;
                    }
                }
            }

            const BLOCKED_EXTENSIONS = ['exe', 'bat', 'cmd', 'sh', 'php', 'pl', 'cgi', 'dll', 'docx', 'doc', 'xlsx', 'xls', 'pptx', 'ppt', 'heic', 'raw', 'psb', 'eps'];

            for (let file of files) {
                // Extension Check (Blacklist)
                const ext = file.name.split('.').pop().toLowerCase();
                if (BLOCKED_EXTENSIONS.includes(ext)) {
                    RFModal.alert(
                        '未対応のファイル形式です',
                        `申し訳ありませんが、アップロードされた「${file.name}」はセキュリティまたはシステム上の理由により未対応です。<br><br>` +
                        `詳細は <a href="/pages/data#toc02" target="_blank" style="text-decoration:underline; color:#000;">入稿データについて</a> をご確認ください。`
                    );
                    continue;
                }

                // Size Check (1GB)
                if (file.size > 1073741824) {
                    this.showError(this.elements.dropzone, `${file.name} は1GBを超えているためアップロードできません。`);
                    continue;
                }

                // create Storage Ref
                const fb = window.RF_FIREBASE;
                if (!fb) continue;
                if (!this.storage) this.storage = fb.storage;
                const storagePath = `uploads/${Date.now()}_${file.name}`;
                const storageRef = fb.ref(this.storage, storagePath);
                const uploadTask = fb.uploadBytesResumable(storageRef, file);

                // Add to list
                const fileId = Date.now() + Math.random().toString(36).substr(2, 9);
                const fileObj = {
                    id: fileId,
                    file: file,
                    task: uploadTask,
                    ref: storageRef,
                    name: file.name, // Keep full name for data
                    downloadUrl: null
                };
                this.uploadedFiles.push(fileObj);

                // UI Item
                const item = document.createElement('div');
                item.className = 'rf-file-item';
                // Store Dimensions
                item.dataset.w = "";
                item.dataset.h = "";


                // Thumbnail Logic (Icons + Generator)
                const thumbGen = new ThumbnailGenerator();
                let thumbHTML = '';

                // 1. Standard Images (Immediate)
                if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext)) {
                    const objectUrl = URL.createObjectURL(file);
                    thumbHTML = `<img src="${objectUrl}" class="rf-file-thumb" alt="preview">`;
                } else {
                    // 2. Special Formats (Initial Loading -> Async Generate -> Fallback Icon)

                    // SVG Icons Definitions (for Fallback)
                    let iconPath = '';
                    const iconStyle = 'width: 40px; height: 40px; stroke-width: 1.5;';
                    if (['ai', 'pdf'].includes(ext)) {
                        iconPath = `<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>`;
                    } else if (['psd', 'tiff', 'tif'].includes(ext)) {
                        iconPath = `<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>`;
                    } else {
                        iconPath = `<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>`;
                    }

                    const fallbackIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-linecap="round" stroke-linejoin="round" style="${iconStyle}">${iconPath}</svg>`;
                    const thumbId = `thumb-${fileId}`;

                    // Initial HTML: Loading Spinner
                    // Using simple CSS spinner
                    const spinnerHTML = `
                    <div class="rf-thumb-spinner" style="width:20px; height:20px; border:2px solid #ccc; border-top-color:#333; border-radius:50%; animation: rf-spin 1s linear infinite;"></div>
                    <style>@keyframes rf-spin {to{transform: rotate(360deg);}}</style>
                `;

                    thumbHTML = `<div id="${thumbId}" style="display:flex; align-items:center; justify-content:center; width:60px; height:60px; background:#f9f9f9; border-radius:4px;">
                                ${spinnerHTML}
                             </div>`;

                    // Async Generation
                    // Use setTimeout to allow UI to render the spinner before heavy JS starts
                    setTimeout(() => {
                        thumbGen.generate(file).then(url => {
                            const container = document.getElementById(thumbId);
                            if (!container) return;

                            if (url) {
                                // Success: Show Image
                                container.innerHTML = `<img src="${url}" class="rf-file-thumb" alt="preview" style="width:100%; height:100%; object-fit:contain;">`;
                                container.style.background = 'transparent';
                            } else {
                                // Failure: Show Fallback Icon
                                container.innerHTML = fallbackIconHTML;
                            }
                        }).catch(e => {
                            const container = document.getElementById(thumbId);
                            if (container) container.innerHTML = fallbackIconHTML;
                        });
                    }, 50);
                }

                // Truncate Filename for Display
                const displayName = this.truncateFilename(file.name);

                // Default Resolution Text
                let resText = '';

                // Async Metadata Reading
                ImageMetadataReader.read(file).then(meta => {
                    if (meta) {
                        item.dataset.w = meta.width;
                        item.dataset.h = meta.height;

                        const dpi = this.calculateDPI(meta.width, meta.height);
                        let text = `解像度: ${meta.width} x ${meta.height} px`;
                        if (dpi) {
                            text += ` / <span>${dpi} dpi</span>`;
                        }
                        const badge = item.querySelector('.rf-file-res-badge');
                        if (badge) {
                            badge.innerHTML = text;
                            badge.style.display = 'block';
                            badge.style.color = '#666'; // Always neutral
                        }
                    }
                });

                // Improved File Item
                item.innerHTML = `
                <div class="rf-file-info">
                    ${thumbHTML}
                    <div class="rf-file-details">
                        <span class="rf-file-name" title="${file.name}">${displayName}</span>
                        <span class="rf-file-size">${this.formatBytes(file.size)}</span>
                        <div class="rf-file-res-badge" style="display:none; font-size: 11px; color: #666; margin-top: 4px;"></div>
                    </div>
                </div>

                <!-- Per-Image Quantity -->
                <div class="rf-file-qty-wrapper" style="margin-left: auto; margin-right: 15px; display: flex; flex-direction: column; align-items: flex-end;">
                    <div style="font-size: 10px; color: #888; margin-bottom: 2px;">枚数</div>
                    <input type="number" 
                           class="rf-img-qty" 
                           value="1" 
                           min="1" 
                           style="width: 50px; padding: 4px; border: 1px solid #ddd; border-radius: 4px; text-align: center;"
                           onchange="window.rfForm.validateTotalQuantity(this, true)" 
                    />
                </div>

                <div class="rf-file-meta">
                    <!-- Circular Progress SVG -->

                    <button type="button" class="rf-file-remove" aria-label="削除">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                </div>
            `;

                this.elements.fileList.appendChild(item);
                this.checkUploadStatusAndToggleSubmit();



                // Remove Event Listener
                const removeBtn = item.querySelector('.rf-file-remove');
                removeBtn.addEventListener('click', () => {
                    this.removeFile(file.name, item);
                    // Also cancel upload task?
                    if (uploadTask && uploadTask.snapshot.state === 'running') {
                        uploadTask.cancel();
                    }
                });

                // Quantity Change Listener
                const qtyInput = item.querySelector('.rf-img-qty');
                qtyInput.addEventListener('change', (e) => {
                    if (e.target.value < 1) e.target.value = 1;
                    this.validateTotalQuantity(e.target);
                });
                qtyInput.addEventListener('click', (e) => e.stopPropagation());

                // Bind Upload Task Events
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                        item.style.setProperty('--progress', progress + '%');
                    },
                    (error) => {
                        console.error("Upload failed:", error);
                        item.classList.add('rf-error');
                        this.checkUploadStatusAndToggleSubmit();
                        // Clean up array?
                    },
                    async () => {
                        const downloadURL = await window.RF_FIREBASE.getDownloadURL(uploadTask.snapshot.ref);
                        if (document.body.contains(item)) {
                            // Update object in array with URL
                            fileObj.downloadUrl = downloadURL;
                            this.updateHiddenFilesInput();
                            item.classList.add('rf-upload-complete');
                            this.checkUploadStatusAndToggleSubmit();
                        }
                    }
                );
            }
        }



        removeFile(fileName, itemElement) {
            // Remove from Array
            this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== fileName);

            // Remove from DOM
            if (itemElement && itemElement.parentNode) {
                itemElement.parentNode.removeChild(itemElement);
            }

            // Update Hidden Inputs
            this.updateHiddenFilesInput();
            this.checkUploadStatusAndToggleSubmit();

            // Hide Remarks Field if empty
            if (this.uploadedFiles.length === 0) {
                const remarksGroup = this.container.querySelector('#rf-file-remarks-group');
                if (remarksGroup) remarksGroup.style.display = 'none';
            }
        }

        updateHiddenFilesInput() {
            // Collect names with quantities
            const items = this.elements.fileList.querySelectorAll('.rf-file-item');
            const fileData = [];

            items.forEach((item, index) => {
                // Find corresponding file in uploadedFiles to get clean name/url?
                // Actually uploadedFiles relies on push order which matches DOM append order usually, 
                // but verify if user removes items.
                // Better: attached data to item? or finding by name.
                const nameEl = item.querySelector('.rf-file-name');
                const qtyEl = item.querySelector('.rf-img-qty');

                if (nameEl && qtyEl) {
                    const name = nameEl.textContent.trim();
                    const qty = parseInt(qtyEl.value) || 1;
                    fileData.push(`${name} (${qty}枚)`);
                }
            });

            const names = fileData.join(', ');
            // [FIX] Filter out null/empty URLs to prevent missing links
            const urls = this.uploadedFiles
                .map(f => f.downloadUrl)
                .filter(url => url && url.trim() !== '')
                .join(', ');

            const namesInput = this.container.querySelector('#rf-file-names');
            const urlsInput = this.container.querySelector('#rf-file-urls');

            if (namesInput) namesInput.value = names;
            if (urlsInput) urlsInput.value = urls;

            console.log("RF: Updated Hidden Inputs", { names, urls, totalFiles: this.uploadedFiles.length, completedUrls: urls.split(',').filter(u => u.trim()).length });
        }

        checkUploadStatusAndToggleSubmit() {
            // [FIX] Check for In-Progress OR Failed Uploads
            const uploadingItems = this.elements.fileList.querySelectorAll('.rf-file-item:not(.rf-upload-complete):not(.rf-error)');
            const errorItems = this.elements.fileList.querySelectorAll('.rf-file-item.rf-error');

            const btn = this.elements.addToCartBtn || this.container.querySelector('.rf-btn-add-to-cart');

            if (btn) {
                // [FIX] Disable if uploading OR error exists
                if (uploadingItems.length > 0) {
                    btn.disabled = true;
                    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
                    btn.textContent = 'アップロード中...';
                } else if (errorItems.length > 0) {
                    // [NEW] Disable on Error and prompt removal
                    btn.disabled = true;
                    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
                    btn.textContent = 'エラーファイルを削除してください';
                } else {
                    btn.disabled = false;
                    if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
                    else btn.textContent = 'カートに入れる';
                }
            }
        }

        showError(element, msg) {
            element.classList.add('rf-input-error');
            setTimeout(() => element.classList.remove('rf-input-error'), 400);

            if (msg && this.elements.uploadError) {
                this.elements.uploadError.textContent = msg;
                this.elements.uploadError.style.display = 'block';
            }
        }

        showTooltip(target) {
            const textKey = target.dataset.tooltip;
            const container = this.container.querySelector('#rf-tooltip-container');
            const content = this.container.querySelector('#rf-tooltip-content');

            const texts = {
                'layout-info': '「フチあり」は画像周囲に白フチがつきます。\n「フチなし」は用紙いっぱいに印刷されます（画像が数mmカットされます）。'
            };

            content.innerText = texts[textKey] || '';

            const rect = target.getBoundingClientRect();
            container.style.left = rect.left + 'px';
            container.style.top = (rect.bottom + 10) + 'px';
            container.classList.add('rf-visible');
        }

        hideTooltip() {
            this.container.querySelector('#rf-tooltip-container').classList.remove('rf-visible');
        }


    }

    // Expose to global scope for module entry point
    window.RationalFuturismForm = RationalFuturismForm;
}
